import slugify from 'slugify'

export default function cleanFilename(filename: string) {
  return slugify(filename, {})
}
